import { render } from "./AdminEventList.vue?vue&type=template&id=4f8fd810"
import script from "./AdminEventList.vue?vue&type=script&lang=js"
export * from "./AdminEventList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__